import VasDownloadSampleReportV2 from "../../shared/vas-download-sample-report-v2";
import PreDeliveryInspectionBanner from "../pre-delivery-inspection-banner/component";
import PreDeliveryInspectionCarDetails from "../pre-delivery-inspection-car-details/component";
import PreDeliveryInspectionCities from "../pre-delivery-inspection-cities/component";
import PreDeliveryInspectionDetails from "../pre-delivery-inspection-details/component";
import PreDeliveryInspectionEasySteps from "../pre-delivery-inspection-easy-steps/component";
import PreDeliveryInspectionRating from "../pre-delivery-inspection-rating/component";
import PreDeliveryInspectionReason from "../pre-delivery-inspection-reason/component";
import PreDeliveryInspectionServices from "../pre-delivery-inspection-services/component";
import PreDeliveryInspectionTestimonials from "../pre-delivery-inspection-testimonials/component";

export const vehicleAccordionReduxKeyNames = {
    selectedBrandInfo: "selectedBrandInfo",
    selectedModelInfo: "selectedModelInfo"
};

export const PAGE_LAYOUT = {
    PDI_HERO_BANNER: PreDeliveryInspectionBanner,
    PDI_REVEAL_ISSUES: PreDeliveryInspectionReason,
    PDI_TRUSTED: PreDeliveryInspectionRating,
    PDI_QUALITY_CHECK: PreDeliveryInspectionCarDetails,
    PDI_SAMPLE_REPORT: VasDownloadSampleReportV2,
    PDI_3STEP_INSPECTION: PreDeliveryInspectionEasySteps,
    PDI_TESTIMONIAL: PreDeliveryInspectionTestimonials,
    PDI_VIDEO: PreDeliveryInspectionServices,
    PDI_CITIES: PreDeliveryInspectionCities,
    PDI_SEO_CONTENT: PreDeliveryInspectionDetails
};
